import React, { useEffect, useState, useRef } from "react";
import { handlePayment } from "../buying/Buy";
import { toast } from "react-toastify";
import {
  fetchCartItems,
  handleDecrease,
  handleIncrease,
  handleRemove,
} from "../Cart/CartFunctions";
import useNavigation from "../Components/DynamicComp/Navigation";
import { FetchCoupons } from "../Coupons/CouponFunction";
import { useParams } from "react-router-dom";
import { getetotalamount } from "../buying/Functions";
import { getData, postData } from "../global/Globalapi";
import { IoArrowBackOutline } from "react-icons/io5";

const CheckoutForm = () => {
  const { userid, couponid, orderId } = useParams();
  const [orderTotal, setOrderTotal] = useState(0);
  const orderTotalRef = useRef(0);

  const navigate = useNavigation();
  // const { userid, couponid } = useParams();
  const [cart, setCart] = useState([]);
  const [selectedCoupon, setSelectedCoupon] = useState("");
  const [couponInput, setCouponInput] = useState("");
  const [couponError, setCouponError] = useState("");
  const [deliveryType, setDeliveryType] = useState("");
  const [deliveryCharge, setDeliveryCharge] = useState(0);

  const [form, setForm] = useState({
    name: "", 
    address: "",
    pincode: "",
    city: "",
    phone: "",
  });
  const [refresh, setRefresh] = useState(false);
  const [coupons, setcoupons] = useState([]);
  const userString = localStorage.getItem("user");
  const user = userString ? JSON.parse(userString) : null;
  const userId = user?.user_id;
  const TAKEAWAY_STORAGE_KEY = `takeaway_details_${userId || "guest"}`;
// const [otp, setOtp] = useState("");
const [otpSent, setOtpSent] = useState(false);
const [isPhoneVerified, setIsPhoneVerified] = useState(false);
const [otp, setOtp] = useState(["", "", "", ""]);
const [otpTimer, setOtpTimer] = useState(30);
const [canResendOtp, setCanResendOtp] = useState(false);
const saveTakeawayDetails = (data) => {
  localStorage.setItem(TAKEAWAY_STORAGE_KEY, JSON.stringify(data));
};

const getTakeawayDetails = () => {
  try {
    const saved = localStorage.getItem(TAKEAWAY_STORAGE_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch (error) {
    console.error("Failed to parse takeaway details:", error);
    return null;
  }
};

const SAFEDELIVERY_STORAGE_KEY = `safe_delivery_details_${userId || "guest"}`;

const saveSafeDeliveryDetails = (data) => {
  localStorage.setItem(SAFEDELIVERY_STORAGE_KEY, JSON.stringify(data));
};

const getSafeDeliveryDetails = () => {
  try {
    const saved = localStorage.getItem(SAFEDELIVERY_STORAGE_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch (error) {
    console.error("Failed to parse safe delivery details:", error);
    return null;
  }
};

useEffect(() => {
  if (deliveryType !== "safe") return;

  const savedSafeDelivery = getSafeDeliveryDetails();

  if (!savedSafeDelivery) return;

  setForm((prev) => ({
    ...prev,
    name: savedSafeDelivery.name || prev.name || "",
    address: savedSafeDelivery.address || prev.address || "",
    city: savedSafeDelivery.city || prev.city || "",
    pincode: savedSafeDelivery.pincode || prev.pincode || "",
    phone: savedSafeDelivery.phone || prev.phone || "",
  }));
}, [deliveryType, userId]);

  const getDeliveryOptions = () => {
    let hasHome = false;
    let hasTakeaway = false;
    let hasSafe = false;

    let maxHomeAmount = 0;
    let maxTakeawayAmount = 0;
    let maxSafeAmount = 0;

    cart.forEach((item) => {
      if (item.home_delivery === 1) {
        hasHome = true;
        maxHomeAmount = Math.max(
          maxHomeAmount,
          parseFloat(item.home_delivery_amount || 0),
        );
      }

      if (item.take_away === 1) {
        hasTakeaway = true;
        maxTakeawayAmount = Math.max(
          maxTakeawayAmount,
          parseFloat(item.take_away_amount || 0),
        );
      }

      if (item.safe_delivery === 1) {
        hasSafe = true;
        maxSafeAmount = Math.max(
          maxSafeAmount,
          parseFloat(item.safe_delivery_amount || 0),
        );
      }
    });

    return {
      hasHome,
      hasTakeaway,
      hasSafe,
      maxHomeAmount,
      maxTakeawayAmount,
      maxSafeAmount,
    };
  };

  const deliveryOptions = getDeliveryOptions();

  const {
    hasHome,
    hasTakeaway,
    hasSafe,
    maxHomeAmount,
    maxTakeawayAmount,
    maxSafeAmount,
  } = deliveryOptions;
  // useEffect(() => {
  //   if (!userId) return;

  //   getData(`/user/last-address/${userId}`)
  //     .then(res => {
  //       console.log("Last address FULL response:", res);

  //       const row = res; // ✅ FIXED

  //       if (!row) return;

  //       const fullAddress = row.address || "";

  //       let street = "";
  //       let city = "";
  //       let pincode = "";

  //       // Example: "thoothukudi, thoothukudi - 628005"
  //       if (fullAddress.includes(",")) {
  //         const parts = fullAddress.split(",");
  //         street = parts[0]?.trim() || "";

  //         if (parts[1]?.includes("-")) {
  //           const cityPin = parts[1].split("-");
  //           city = cityPin[0]?.trim() || "";
  //           pincode = cityPin[1]?.trim() || "";
  //         }
  //       } else {
  //         street = fullAddress;
  //       }

  //       setForm({
  //         address: street,
  //         city: city,
  //         pincode: pincode,
  //         phone: row.phone || "",
  //       });
  //     })
  //     .catch(err => {
  //       console.error("Address fetch error:", err);
  //     });
  // }, [userId]);
  console.log("CHECKOUT userId:", userId);

  // useEffect(() => {
  //   if (!userId) {
  //     console.log("❌ userId missing, API not called");
  //     return;
  //   }

  //   console.log("✅ Calling address API...");

  //   getData(`/user/last-address/${userId}`)
  //     .then(data => {
  //       console.log("✅ RAW API DATA:", data);
  //     })
  //     .catch(err => {
  //       console.error("❌ API ERROR:", err);
  //     });
  // }, [userId]);
useEffect(() => {
  if (deliveryType !== "takeaway") return;

  const savedTakeaway = getTakeawayDetails();

  setForm((prev) => ({
    ...prev,
    name:
      savedTakeaway?.name ||
      prev.name ||
      user?.name ||
      user?.username ||
      "",
    phone:
      savedTakeaway?.phone ||
      prev.phone ||
      user?.mobile ||
      "",
  }));
}, [deliveryType, userId]);

  useEffect(() => {
    if (!userId) return;

    console.log("✅ Calling address API...");

    getData(`/user/last-address/${userId}`)
      .then((res) => {
        console.log("✅ RAW API DATA:", res);

        // ✅ THIS IS THE FIX
        const row = res?.data?.[0];

        if (!row) {
          console.warn("❌ No address row found");
          return;
        }

        const fullAddress = row.address || "";

        // REMOVE SAFEDELIVERY / HOMEDELIVERY WORDS ONLY
        const cleanedAddress = fullAddress.replace(
          /^(SAFEDELIVERY|HOMEDELIVERY)\s*:\s*/i,
          "",
        );

        let street = "";
        let city = "";
        let pincode = "";

        // if (cleanedAddress.includes(",")) {
        //   const parts = cleanedAddress.split(",");
        //   street = parts[0]?.trim() || "";

        //   if (parts[1]?.includes("-")) {
        //     const cityPin = parts[1].split("-");
        //     city = cityPin[0]?.trim() || "";
        //     pincode = cityPin[1]?.trim() || "";
        //   }
        // }
        const parts = cleanedAddress.split(",");

// ✅ Extract name
const extractedName = parts[0]?.trim() || "";

// ✅ Extract pincode from last part
const lastPart = parts[parts.length - 1] || "";

if (lastPart.includes("-")) {
  const cityPin = lastPart.split("-");
  city = cityPin[0]?.trim() || "";
  pincode = cityPin[1]?.trim() || "";
}

// ✅ Remaining parts = address (excluding name & last part)
const addressParts = parts.slice(1, parts.length - 1);

// join all as street
street = addressParts.join(",").trim();
        
        console.log("✅ SETTING FORM:", {
          street,
          city,
          pincode,
          phone: row.phone,
        });
       setForm((prev) => ({
  ...prev,
  name: prev.name || extractedName || user?.name || user?.username || "",
  address: street,
  city,
  pincode,
  phone: row.phone || prev.phone || user?.mobile || "",
}));
      })
      .catch((err) => console.error("❌ Address fetch error:", err));
  }, [userId]);

  useEffect(() => {
    if (userid && userId && String(userId) !== String(userid)) {
      toast.error("Unauthorized access. Redirecting...");
      navigate.Goto("/");
    }
  }, [userid, userId]);

  let showHome = false;
  let showTakeaway = false;
  let showSafe = false;

  // 🔥 YOUR CUSTOM RULES

  if (hasHome && !hasTakeaway && !hasSafe) {
    showHome = true;
  } else if (!hasHome && hasTakeaway && !hasSafe) {
    showTakeaway = true;
  } else if (!hasHome && !hasTakeaway && hasSafe) {
    showSafe = true;
  } else if (hasHome && hasSafe && !hasTakeaway) {
    showHome = true;
    showSafe = true;
  } else if (hasHome && hasTakeaway && hasSafe) {
    // YOUR RULE: show only Safe + Takeaway
    showSafe = true;
    showTakeaway = true;
  } else {
    if (hasHome) showHome = true;
    if (hasTakeaway) showTakeaway = true;
    if (hasSafe) showSafe = true;
  }

  // useEffect(() => {
  //   if (!orderId) return;

  //   getData(`/orders/${orderId}`)
  //     .then((res) => {
  //       const order = res.data;
  //       console.log("Order data for payment retry:", order);

  //       setCart(
  //         (order.products || []).map((item) => ({
  //           ...item,
  //           quantity: item.quantity ?? item.qty ?? 1,
  //           image_url: item.image_url || item.image || "",
  //           amount: item.amount || item.price || 0,
  //         })),
  //       );
  //       console.log("Order products set to cart:", order.products);
  //       console.log("Order image_url image_url:", order.image_url);

  //       setDeliveryType(
  //         order.delivery_type === "TAKEAWAY" ? "takeaway" : "home",
  //       );

  //       if (order.address && order.address !== "STORE PICKUP") {
  //         setForm({
  //           address: order.address,
  //           phone: order.phone || "",
  //           city: "",
  //           pincode: "",
  //         });
  //       }
  //     })
  //     .catch(() => {
  //       toast.error("Unable to load order for payment");
  //       navigate("/my-orders");
  //     });
  // }, [orderId]);
  // useEffect(() => {
  //   if (!orderId) return;

  //   getData(`/orders/${orderId}`)
  //     .then((res) => {
  //       const order = res.data;
  //       console.log("Order data for payment retry:", order);

  //       setCart(
  //         (order.products || []).map((item) => ({
  //           ...item,
  //           quantity: item.quantity ?? item.qty ?? 1,
  //           image_url: item.image_url || item.image || "",
  //           amount: item.amount || item.price || 0,
  //         }))
  //       );

  //       setDeliveryType(
  //         order.delivery_type === "TAKEAWAY" ? "takeaway" : "home"
  //       );

  //       // ✅ FIX ADDRESS PARSING HERE
  //       if (order.address && order.address !== "STORE PICKUP") {
  //         let street = "";
  //         let city = "";
  //         let pincode = "";

  //         const fullAddress = order.address;

  //         // Expected formats:
  //         // 1) Street, City - Pincode
  //         // 2) City - Pincode
  //         if (fullAddress.includes("-")) {
  //           const [left, pin] = fullAddress.split("-");
  //           pincode = pin?.trim() || "";

  //           if (left.includes(",")) {
  //             const [streetPart, cityPart] = left.split(",");
  //             street = streetPart?.trim() || "";
  //             city = cityPart?.trim() || "";
  //           } else {
  //             city = left.trim();
  //           }
  //         } else {
  //           street = fullAddress.trim();
  //         }

  //         setForm({
  //           address: street,
  //           city,
  //           pincode,
  //           phone: order.phone || "",
  //         });
  //       }
  //     })
  //     .catch(() => {
  //       toast.error("Unable to load order for payment");
  //       navigate("/my-orders");
  //     });
  // }, [orderId]);
  // useEffect(() => {
  //   if (!orderId) return;
  //   // ✅ RESET OLD PENDING PAYMENT STATE
  //   setCart([]);
  //   setOrderTotal(0);
  //   getData(`/orders/${orderId}`)
  //     .then((res) => {
  //       const order = res.data;
  //       console.log("Order data for payment retry:", order);

  //       const products = (order.products || []).map((item) => ({
  //         ...item,
  //         quantity: item.quantity ?? item.qty ?? 1,
  //         image_url: item.image_url || item.image || "",
  //         amount: Number(item.amount || item.price || 0),
  //       }));

  //       setCart(products);

  //       // ✅ THIS LINE FIXES YOUR ISSUE
  //       const calculatedTotal = products.reduce(
  //         (sum, item) => sum + item.amount * item.quantity,
  //         0
  //       );
  //       setOrderTotal(calculatedTotal);

  //       setDeliveryType(
  //         order.delivery_type === "TAKEAWAY" ? "takeaway" : "home"
  //       );

  //       if (order.address && order.address !== "STORE PICKUP") {
  //         let street = "";
  //         let city = "";
  //         let pincode = "";

  //         const fullAddress = order.address;

  //         if (fullAddress.includes("-")) {
  //           const [left, pin] = fullAddress.split("-");
  //           pincode = pin?.trim() || "";

  //           if (left.includes(",")) {
  //             const [streetPart, cityPart] = left.split(",");
  //             street = streetPart?.trim() || "";
  //             city = cityPart?.trim() || "";
  //           } else {
  //             city = left.trim();
  //           }
  //         } else {
  //           street = fullAddress.trim();
  //         }

  //         setForm({
  //           address: street,
  //           city,
  //           pincode,
  //           phone: order.phone || "",
  //         });
  //       }
  //     })
  //     .catch(() => {
  //       toast.error("Unable to load order for payment");
  //       navigate("/my-orders");
  //     });
  // }, [orderId]);
  useEffect(() => {
    if (!orderId) return;

    // ✅ RESET OLD PENDING PAYMENT STATE
    setCart([]);
    setOrderTotal(0);
    orderTotalRef.current = 0; // 🔥 VERY IMPORTANT

    getData(`/orders/${orderId}`)
      .then((res) => {
        const order = res.data;
        console.log("Order data for payment retry:", order);

        const products = (order.products || []).map((item) => ({
          ...item,
          quantity: item.quantity ?? item.qty ?? 1,
          image_url: item.image_url || item.image || "",
          amount: Number(item.amount || item.price || 0),
        }));

        // ✅ SET CART
        setCart(products);

        // ✅ ALWAYS RECALCULATE TOTAL FROM THIS ORDER ONLY
        // const calculatedTotal = products.reduce(
        //   (sum, item) => sum + item.amount * item.quantity,
        //   0
        // );
        const calculatedTotal = products.reduce(
          (sum, item) => sum + item.amount,
          0,
        );

        setOrderTotal(calculatedTotal);
        orderTotalRef.current = calculatedTotal; // 🔥 THIS FIXES RAZORPAY

        setDeliveryType(
          order.delivery_type === "TAKEAWAY" ? "takeaway" : "home",
        );

        // ✅ ADDRESS PARSING (UNCHANGED LOGIC)
        if (order.address && order.address !== "STORE PICKUP") {
          let street = "";
          let city = "";
          let pincode = "";

          const fullAddress = order.address;

          if (fullAddress.includes("-")) {
            const [left, pin] = fullAddress.split("-");
            pincode = pin?.trim() || "";

            if (left.includes(",")) {
              const [streetPart, cityPart] = left.split(",");
              street = streetPart?.trim() || "";
              city = cityPart?.trim() || "";
            } else {
              city = left.trim();
            }
          } else {
            street = fullAddress.trim();
          }

          setForm({
            address: street,
            city,
            pincode,
            phone: order.phone || "",
          });
        }
      })
      .catch(() => {
        toast.error("Unable to load order for payment");
        navigate("/my-orders");
      });
  }, [orderId]);

  console.log("Checkout orderId from URL:", orderId);

  // useEffect(() => {
  //   fetchCartItems(userId,setCart);
  //   FetchCoupons(setcoupons,(fetchedCoupons)=>{
  //    if (couponid) {
  //     const matched = fetchedCoupons.find(
  //       (c) => String(c.id) === String(couponid) && c.status === "active"
  //     );

  //     if (matched) {
  //       setSelectedCoupon(matched);
  //       setCouponInput(matched.coupon_code.toUpperCase());
  //       setCouponError("");
  //       toast.success(`Coupon ${matched.coupon_code} auto-applied!`);
  //     } else {
  //       setCouponError("Invalid or inactive coupon.");
  //       toast.error("Coupon in URL is not valid.");
  //     }
  //   }
  //   });

  // }, [refresh]);

  useEffect(() => {
    // ❌ Skip cart fetch during retry payment
    if (orderId) return;

    fetchCartItems(userId, setCart);

    FetchCoupons(setcoupons, (fetchedCoupons) => {
      if (couponid) {
        const matched = fetchedCoupons.find(
          (c) => String(c.id) === String(couponid) && c.status === "active",
        );

        if (matched) {
          setSelectedCoupon(matched);
          setCouponInput(matched.coupon_code.toUpperCase());
          toast.success(`Coupon ${matched.coupon_code} auto-applied!`);
        }
      }
    });
  }, [refresh, orderId]);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setForm((prev) => ({ ...prev, [name]: value }));
  // };
  const handleChange = (e) => {
  const { name, value } = e.target;

  const updatedValue =
    name === "phone" ? value.replace(/\D/g, "").slice(0, 10) : value;

  setForm((prev) => ({
    ...prev,
    [name]: updatedValue,
  }));

  // if (name === "phone") {
  //   setOtp("");
  //   setOtpSent(false);
  //   setIsPhoneVerified(false);
  // }
//   if (name === "phone") {
//   const updatedPhone = value.replace(/\D/g, "").slice(0, 10);

//   setOtp(["", "", "", ""]);
//   setOtpSent(false);

//   const savedVerifiedPhone = localStorage.getItem(`verified_phone_${userId || "guest"}`);

//   if (savedVerifiedPhone === updatedPhone) {
//     setIsPhoneVerified(true);
//   } else {
//     setIsPhoneVerified(false);
//   }
// }
if (name === "phone") {
  setOtp(["", "", "", ""]);
  setOtpSent(false);
  setIsPhoneVerified(false);
}
};
// useEffect(() => {
//   const currentPhone = (form.phone || "").trim();
//   const savedVerifiedPhone = localStorage.getItem(
//     `verified_phone_${userId || "guest"}`
//   );

//   if (currentPhone.length === 10 && savedVerifiedPhone === currentPhone) {
//     setIsPhoneVerified(true);
//     setOtpSent(false);
//     setOtp(["", "", "", ""]);
//   } else {
//     setIsPhoneVerified(false);
//   }
// }, [form.phone, userId]);
useEffect(() => {
  const currentPhone = (form.phone || "").trim();
  const savedVerifiedPhone = localStorage.getItem(
    `verified_phone_${userId || "guest"}`
  );

  if (
    currentPhone.length === 10 &&
    savedVerifiedPhone &&
    savedVerifiedPhone === currentPhone
  ) {
    setIsPhoneVerified(true);
    setOtpSent(false);
    setOtp(["", "", "", ""]);
  } else {
    setIsPhoneVerified(false);
  }
}, [form.phone, userId]);
useEffect(() => {
  let interval;

  if (otpSent && otpTimer > 0) {
    interval = setInterval(() => {
      setOtpTimer((prev) => prev - 1);
    }, 1000);
  }

  if (otpTimer === 0) {
    setCanResendOtp(true);
  }

  return () => {
    if (interval) clearInterval(interval);
  };
}, [otpSent, otpTimer]);
// const handleSendOtp = () => {
//   if (form.phone.trim().length !== 10) {
//     toast.error("Please enter a valid 10-digit phone number");
//     return;
//   }

//   setOtpSent(true);
//   setOtp(["", "", "", ""]);
//   setOtpTimer(30);
//   setCanResendOtp(false);

//   toast.success("OTP sent successfully");
// };
const handleSendOtp = async () => {
  if (form.phone.trim().length !== 10) {
    toast.error("Please enter a valid 10-digit phone number");
    return;
  }

  try {
    const res = await postData("/orders/send-otp", {
      mobile_number: form.phone.trim(),
    });

    if (res.data.status !== "ok") {
      toast.error(res.data.message || "Failed to send OTP");
      return;
    }

    setOtpSent(true);
    setOtp(["", "", "", ""]);
    setOtpTimer(30);
    setCanResendOtp(false);

    toast.success(res.data.message || "OTP sent successfully");
  } catch (error) {
    console.error("send otp error:", error);
    toast.error("Server error while sending OTP");
  }
};
// const handleResendOtp = () => {
//   if (form.phone.trim().length !== 10) {
//     toast.error("Please enter a valid 10-digit phone number");
//     return;
//   }

//   setOtp(["", "", "", ""]);
//   setOtpTimer(30);
//   setCanResendOtp(false);

//   toast.success("OTP resent successfully");
// };
const handleResendOtp = async () => {
  if (form.phone.trim().length !== 10) {
    toast.error("Please enter a valid 10-digit phone number");
    return;
  }

  try {
    const res = await postData("/orders/send-otp", {
      mobile_number: form.phone.trim(),
    });

    if (res.data.status !== "ok") {
      toast.error(res.data.message || "Failed to resend OTP");
      return;
    }

    setOtp(["", "", "", ""]);
    setOtpTimer(30);
    setCanResendOtp(false);
    setOtpSent(true);

    toast.success(res.data.message || "OTP resent successfully");
  } catch (error) {
    console.error("resend otp error:", error);
    toast.error("Server error while resending OTP");
  }
};
const handleVerifyOtp = async () => {
  const enteredOtp = otp.join("");

  if (enteredOtp.length !== 4) {
    toast.error("Please enter 4-digit OTP");
    return;
  }

  try {
    const res = await postData("/orders/verify-otp", {
      mobile_number: form.phone.trim(),
      otp: enteredOtp,
    });

    if (res.data.status !== "ok") {
      toast.error(res.data.message || "Invalid OTP");
      return;
    }

    // ✅ Save verified phone
    localStorage.setItem(
      `verified_phone_${userId || "guest"}`,
      form.phone.trim()
    );

    setIsPhoneVerified(true);
    setOtpSent(false);
    setOtp(["", "", "", ""]);

    toast.success(res.data.message || "Phone verified successfully");
  } catch (error) {
    console.error("verify otp error:", error);
    toast.error("Server error while verifying OTP");
  }
};
const handleOtpChange = (e, index) => {
  const value = e.target.value.replace(/\D/g, "");

  if (!value) return;

  const newOtp = [...otp];
  newOtp[index] = value;
  setOtp(newOtp);

  // Move to next input
  if (index < 3) {
    const nextInput = document.getElementById(`otp-${index + 1}`);
    nextInput?.focus();
  }
};
const handleOtpKeyDown = (e, index) => {
  if (e.key === "Backspace") {
    const newOtp = [...otp];

    if (otp[index]) {
      newOtp[index] = "";
      setOtp(newOtp);
    } else if (index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      prevInput?.focus();
    }
  }
};
  const applyCoupon = () => {
    const matchedCoupon = activeCoupons.find(
      (c) => c.coupon_code.toUpperCase() === couponInput.trim().toUpperCase(),
    );

    if (matchedCoupon) {
      setSelectedCoupon(matchedCoupon);
      setCouponError("");
      toast.success(`Coupon ${matchedCoupon.coupon_code} applied!`);
    } else {
      setSelectedCoupon("");
      setCouponError("Invalid coupon code.");
      toast.error("No matching coupon found.");
    }
  };

  // const onSubmit = async (e) => {
  //   e.preventDefault();
  //   const { address, city, pincode } = form;
  //  if (!address.trim()) {
  //   toast.error("Please enter your street address.");
  //   return;
  // }
  // if (!city.trim()) {
  //   toast.error("Please enter your city.");
  //   return;
  // }
  // if (!pincode.trim()) {
  //   toast.error("Please enter your pincode.");
  //   return}
  //   if (cart.length === 0) {
  //     toast.warning("Cart is empty.");
  //     return;
  //   }

  //   const fullAddress = `${form.address}, ${form.city} - ${form.pincode}`;
  //   const finalAmount=await totaldata(userId,selectedCoupon)
  //   console.log("hi",finalAmount)
  //   let totalAmount=0
  //   if(finalAmount){
  //      console.log("Final amount response",finalAmount)
  //     const Amount=finalAmount.data.discountedTotal ?? finalAmount.totalAmount ?? totalAmount
  //      totalAmount=parseFloat(Amount)
  //      console.log("final amount",totalAmount);
  //   }
  //   await handlePayment({ address: fullAddress,navigate,totalAmount,cart,phone:form.phone});
  // };
  // const onSubmit = async (e) => {
  //   e.preventDefault();

  //   if (cart.length === 0) {
  //     toast.warning("Cart is empty.");
  //     return;
  //   }

  //   let fullAddress = "STORE PICKUP"; // ✅ default for Take Away

  //   // ✅ Validate ONLY for home delivery
  //   if (deliveryType === "home") {
  //     const { address, city, pincode } = form;

  //     if (!address.trim()) {
  //       toast.error("Please enter your address");
  //       return;
  //     }
  //     if (!city.trim()) {
  //       toast.error("Please enter your city");
  //       return;
  //     }
  //     if (!pincode.trim()) {
  //       toast.error("Please enter your pincode");
  //       return;
  //     }

  //     fullAddress = `${address}, ${city} - ${pincode}`;
  //   }

  //   const finalAmount = await totaldata(userId, selectedCoupon);
  //   let totalAmount = 0;

  //   if (finalAmount) {
  //     totalAmount = parseFloat(
  //       finalAmount.data?.discountedTotal ?? finalAmount.totalAmount ?? 0,
  //     );
  //   }

  //   // ✅ DB WILL RECEIVE "STORE PICKUP" FOR TAKE AWAY
  //   await handlePayment({
  //     address: fullAddress,
  //     navigate,
  //     totalAmount,
  //     cart,
  //     phone: deliveryType === "takeaway" ? "1234567890" : form.phone,
  //     orderId,
  //   });
  // };
  // const onSubmit = async (e) => {
  //   e.preventDefault();

  //   if (cart.length === 0) {
  //     toast.warning("Cart is empty.");
  //     return;
  //   }

  //   let fullAddress = "STORE PICKUP";

  //   if (deliveryType === "home") {
  //     const { address, city, pincode } = form;

  //     if (!address.trim()) {
  //       toast.error("Please enter your address");
  //       return;
  //     }
  //     if (!city.trim()) {
  //       toast.error("Please enter your city");
  //       return;
  //     }
  //     if (!pincode.trim()) {
  //       toast.error("Please enter your pincode");
  //       return;
  //     }

  //     // fullAddress = `${address}, ${city} - ${pincode}`;
  //     if (deliveryType === "safe") {
  //   fullAddress = `SAFEDELIVERY : ${address}, ${city} - ${pincode}`;
  // } else {
  //   // home delivery (unchanged)
  //   fullAddress = `${address}, ${city} - ${pincode}`;
  // }
  //   }

  //   let totalAmount = 0;

  //   // ✅ 🔥 THIS IS THE KEY FIX
  //   if (orderId) {
  //     // RETRY PAYMENT → USE ORDER TOTAL ONLY
  //     totalAmount = orderTotalRef.current;
  //   } else {
  //     // NORMAL CHECKOUT → CALCULATE FROM CART + COUPON
  //     const finalAmount = await totaldata(userId, selectedCoupon);
  //     totalAmount = parseFloat(
  //       finalAmount?.data?.discountedTotal ??
  //       finalAmount?.totalAmount ??
  //       0
  //     );
  //   }

  //   await handlePayment({
  //     address: fullAddress,
  //     navigate,
  //     totalAmount,
  //     cart,
  //     phone: deliveryType === "takeaway" ? "1234567890" : form.phone,
  //     orderId,
  //   });
  // };
  const onSubmit = async (e) => {
    e.preventDefault();

    if (cart.length === 0) {
      toast.warning("Cart is empty.");
      return;
    }

    if (!deliveryType) {
      toast.warning("Please select a delivery option");
      return;
    }
if (!isPhoneVerified) {
  toast.error("Please verify your phone number before proceeding");
  return;
}
    let fullAddress = "STORE PICKUP"; // default → Take Away
if (deliveryType === "takeaway") {
  if (!form.name.trim()) {
    toast.error("Please enter your name");
    return;
  }

  if (!form.phone.trim()) {
    toast.error("Please enter your phone number");
    return;
  }

  if (!/^[0-9]{10}$/.test(form.phone.trim())) {
    toast.error("Please enter a valid 10-digit phone number");
    return;
  }

  saveTakeawayDetails({
    name: form.name.trim(),
    phone: form.phone.trim(),
  });

  fullAddress = `TAKEAWAY : ${form.name}`;
}
    const { address, city, pincode } = form;

    // ✅ Home Delivery
    if (deliveryType === "home") {
      if (!address.trim()) {
        toast.error("Please enter your address");
        return;
      }
      if (!city.trim()) {
        toast.error("Please enter your city");
        return;
      }
      if (!pincode.trim()) {
        toast.error("Please enter your pincode");
        return;
      }

      fullAddress = `HOMEDELIVERY :${address}, ${city} - ${pincode}`;
    }

    // ✅ Safe Delivery (THIS WAS MISSING PROPERLY)
    if (deliveryType === "safe") {
      if (!form.name.trim()) {
    toast.error("Please enter your name");
    return;
  }
      if (!address.trim() || !city.trim() || !pincode.trim()) {
        toast.error("Please fill address for safe delivery");
        return;
      }
saveSafeDeliveryDetails({
    name: form.name.trim(),
    address: address.trim(),
    city: city.trim(),
    pincode: pincode.trim(),
    phone: form.phone.trim(),
  });
      fullAddress = `SAFEDELIVERY : ${form.name}, ${address}, ${city} - ${pincode}`;
    }

    let paymentAmount;

    if (orderId) {
      paymentAmount = orderTotalRef.current;
    } else {
      paymentAmount = finalTotal; // ✅ USE UI CALCULATED TOTAL
    }

    await handlePayment({
      address: fullAddress,
      navigate,
      totalAmount: paymentAmount,
      cart,
      phone: form.phone,
      orderId,
    });
  };
  // const totalAmount = cart.reduce(
  //   (total, item) => total + parseFloat(item.amount),
  //   0
  // )
  // const totalAmount = cart.reduce(
  //   (total, item) => total + parseFloat(item.amount) * (item.quantity || 1),
  //   0,
  // );
  const totalAmount = cart.reduce(
    (total, item) => total + parseFloat(item.amount),
    0,
  );
  // const totalAmount = orderId
  //   ? orderTotal
  //   : cart.reduce(
  //       (total, item) => total + Number(item.amount),
  //       0
  //     );

  const discountedTotal = selectedCoupon
    ? selectedCoupon.promotion_type === "Fixed"
      ? Math.max(totalAmount - parseFloat(selectedCoupon.amount), 0)
      : Math.max(
          totalAmount - (totalAmount * parseFloat(selectedCoupon.amount)) / 100,
          0,
        )
    : totalAmount;

  const finalTotal = discountedTotal + deliveryCharge;
  const activeCoupons = coupons.filter((coupon) => coupon.status === "active");
  const totaldata = async (userId, selectedCoupon) => {
    const couponid = selectedCoupon?.id || "";
    const data = await getetotalamount(userId, couponid);
    console.log("total data", data);
    console.log("userid", userId);
    console.log("coupin id", couponid);
    return data;
  };
  return (
    <div className="max-w-4xl mx-auto px-4 py-6 space-y-6">
      <h2 className="text-2xl font-bold text-gray-800">Checkout</h2>

      <button
        onClick={() => navigate.Goback()}
        className="text-sm bg-[#c97c5d] hover:bg-orange-300 text-black-700 px-4 py-2 rounded-lg transition mb-4"
      >
        <IoArrowBackOutline className="text-2xl" />
      </button>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
        {cart.map((item) => (
          <div
            key={item.id}
            className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition duration-300 overflow-hidden flex flex-col"
          >
            <div className="h-48 bg-gray-100">
              <img
                src={item.image_url}
                alt={item.product_name}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="p-4 flex flex-col justify-between flex-grow">
              <div className="space-y-1">
                <h3 className="text-lg font-semibold text-gray-900 truncate">
                  {item.product_name}
                </h3>
                <p className="text-indigo-600 font-bold text-lg">
                  ₹{item.amount}
                </p>
              </div>

              <div className="mt-4 flex justify-between items-center">
                <div className="flex items-center space-x-2">
                  {/* <button
      // onClick={() => handleDecrease(item.id, item.quantity,setRefresh)}
      className="px-3 py-1 bg-[#c97c5d] rounded text-lg font-bold hover:bg-orange-600"
    > */}
                  <button
                    disabled={!!orderId}
                    onClick={() =>
                      !orderId &&
                      handleDecrease(item.id, item.quantity, setRefresh)
                    }
                    className="px-3 py-1 bg-[#c97c5d] rounded text-lg font-bold hover:bg-orange-600"
                  >
                    -
                  </button>
                  <span className="font-semibold">{item.quantity}</span>
                  {/* <button
      onClick={() => handleIncrease(item.id, setCart,setRefresh)}
      className="px-3 py-1 bg-[#c97c5d] rounded text-lg font-bold hover:bg-orange-600"
    > */}
                  <button
                    disabled={!!orderId}
                    onClick={() =>
                      !orderId && handleIncrease(item.id, setCart, setRefresh)
                    }
                    className="px-3 py-1 bg-[#c97c5d] rounded text-lg font-bold hover:bg-orange-600"
                  >
                    +
                  </button>
                </div>
                {/* <button
    onClick={() => handleRemove(item.id,setCart,userId,setRefresh)}
    // className="text-sm bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition"
    className="text-xs bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded-md transition"
  > */}
                <button
                  disabled={!!orderId}
                  onClick={() =>
                    !orderId &&
                    handleRemove(item.id, setCart, userId, setRefresh)
                  }
                  className="text-xs bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded-md transition"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex gap-x-6 border-b mb-6">
        {showHome && (
          <button
            type="button"
            onClick={() => {
              setDeliveryType("home");
              setDeliveryCharge(maxHomeAmount);
            }}
            className={`px-6 py-2 font-semibold ${
              deliveryType === "home"
                ? "border-b-2 border-blue-600 text-white bg-[#c97c5d]"
                : "text-white bg-gray-500"
            }`}
          >
            Home Delivery
          </button>
        )}

        {showTakeaway && (
          <button
            type="button"
            onClick={() => {
              setDeliveryType("takeaway");
              setDeliveryCharge(0);
            }}
            className={`px-6 py-2 font-semibold ${
              deliveryType === "takeaway"
                ? "border-b-2 border-blue-600 text-white bg-[#c97c5d]"
                : "text-white bg-gray-500"
            }`}
          >
            Take Away
          </button>
        )}

        {showSafe && (
          <button
            type="button"
            onClick={() => {
              setDeliveryType("safe");
              setDeliveryCharge(maxSafeAmount);
            }}
            className={`px-6 py-2 font-semibold ${
              deliveryType === "safe"
                ? "border-b-2 border-blue-600 text-white bg-[#c97c5d]"
                : "text-white bg-gray-500"
            }`}
          >
            Safe Delivery
          </button>
        )}
      </div>

      {deliveryType && (
        <form
          onSubmit={onSubmit}
          className="bg-white rounded-xl shadow-md p-6 space-y-6"
        >
          {(deliveryType === "home" || deliveryType === "safe") && (
            <>
              <h3 className="text-xl font-bold text-gray-800 border-b pb-2">
                Shipping Address
              </h3>
              <div className="flex flex-col">
  <label className="text-sm font-medium text-gray-700 mb-1">
 Name<span className="text-red-500">*</span>
  </label>
  <input
    type="text"
    name="name"
    placeholder="Enter your name"
    value={form.name}
    onChange={handleChange}
    required
    className="border border-gray-300 rounded-lg px-4 py-2
               focus:outline-none focus:ring-2 focus:ring-blue-500"
  />
</div>
              {/* <div className="flex flex-col">
                <label
                  htmlFor="phone"
                  className="text-sm font-medium text-gray-700 mb-1"
                >
                  Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  id="phone"
                  placeholder="e.g. 9876543210"
                  value={form.phone}
                  onChange={handleChange}
                  required
                  pattern="[0-9]{10}"
                  maxLength={10}
                  className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div> */}
<div className="flex flex-col">
  <label
    htmlFor="phone"
    className="text-sm font-medium text-gray-700 mb-1"
  >
    Phone Number<span className="text-red-500">*</span>
  </label>

  {/* <div className="flex flex-col sm:flex-row gap-2"> */}
  <div className="flex items-center gap-2 flex-wrap">
    <input
      type="tel"
      name="phone"
      id="phone"
      placeholder="e.g. 9876543210"
      value={form.phone}
      onChange={handleChange}
      required
      maxLength={10}
        disabled={isPhoneVerified}
      // className="border border-gray-300 rounded-lg px-4 py-2 flex-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
    className={`border rounded-lg px-4 py-2 flex-1 focus:outline-none focus:ring-2 ${
    isPhoneVerified
      ? "border-green-300 bg-green-50 text-gray-600 cursor-not-allowed"
      : "border-gray-300 focus:ring-blue-500"
  }`}
   />

    {form.phone.length === 10 && !otpSent && !isPhoneVerified && (
      <button
        type="button"
        // onClick={() => setOtpSent(true)}
        onClick={handleSendOtp}
        className="bg-[#c97c5d] hover:bg-[#b86d4f] text-white px-4 py-2 rounded-lg font-medium transition"
      >
        Send OTP
      </button>
    )}

    {/* {isPhoneVerified && (
      <span className="px-4 py-2 rounded-lg bg-green-100 text-green-700 font-medium text-sm flex items-center">
        Verified
      </span>
      
    )} */}
    {isPhoneVerified && (
  <div className="flex items-center gap-3">
    <span className="px-4 py-2 rounded-lg bg-green-100 text-green-700 font-medium text-sm flex items-center">
      Verified
    </span>

    {localStorage.getItem(`verified_phone_${userId || "guest"}`) === form.phone && (
      <button
        type="button"
        onClick={() => {
          setIsPhoneVerified(false);
          setOtpSent(false);
          setOtp(["", "", "", ""]);
        }}
        // className="text-sm text-blue-600 hover:text-blue-800 underline"
        className="text-sm text-white bg-[#c97c5d] hover:bg-[#b86d4f] px-3 py-2 rounded-lg"

      >
        Change Number
      </button>
    )}
  </div>
)}
  </div>

  {otpSent && !isPhoneVerified && (
    // <div className="flex flex-col sm:flex-row gap-2 mt-3">
    //   <input
    //     type="text"
    //     placeholder="Enter OTP"
    //     value={otp}
    //     onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
    //     maxLength={6}
    //     className="border border-gray-300 rounded-lg px-4 py-2 flex-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
    //   />

    //   <button
    //     type="button"
    //     onClick={() => setIsPhoneVerified(true)}
    //     className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium transition"
    //   >
    //     Verify
    //   </button>
    // </div>
    <div className="flex flex-col sm:flex-row gap-2 mt-3 items-center">
  <div className="flex gap-2">
    {[...Array(4)].map((_, index) => (
      <input
        id={`otp-${index}`}
        key={index}
        type="text"
        maxLength={1}
        value={otp[index] || ""}
        onChange={(e) => handleOtpChange(e, index)}
        onKeyDown={(e) => handleOtpKeyDown(e, index)}
        className="w-10 h-12 text-center text-lg border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    ))}
  </div>
<div className="flex items-center gap-3 mt-3">
  {!canResendOtp ? (
    <span className="text-sm text-gray-600">
      Resend OTP in <span className="font-semibold text-orange-600">{otpTimer}s</span>
    </span>
  ) : (
    <button
      type="button"
      onClick={handleResendOtp}
      // className="text-sm bg-[#c97c5d] hover:bg-[#b86d4f] text-white px-3 py-2 rounded-lg"
      
  className="bg-[#c97c5d] hover:bg-orange-700 text-white px-4 py-2 rounded-lg font-medium -mt-4"
    >
      Resend OTP
    </button>
  )}
</div>
  {/* <button
    type="button"
    onClick={() => setIsPhoneVerified(true)}
    className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium"
  >
    Verify
  </button> */}
  {/* <button
  type="button"
  onClick={() => {
    const currentPhone = form.phone.trim();

    if (currentPhone.length !== 10) return;

    localStorage.setItem(
      `verified_phone_${userId || "guest"}`,
      currentPhone
    );

    setIsPhoneVerified(true);
    setOtpSent(false);
  }}
  className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium"
>
  Verify
</button> */}
<button
  type="button"
  onClick={handleVerifyOtp}
  className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium"
>
  Verify
</button>
</div>
  )}
</div>
              <div className="flex flex-col">
                <label
                  htmlFor="address"
                  className="text-sm font-medium text-gray-700 mb-1"
                >
                  Street Address<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="address"
                  id="address"
                  placeholder="123 Main Street"
                  value={form.address}
                  onChange={handleChange}
                  required
                  className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label
                    htmlFor="city"
                    className="text-sm font-medium text-gray-700 mb-1"
                  >
                    City<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="city"
                    id="city"
                    placeholder="Your City"
                    value={form.city}
                    onChange={handleChange}
                    required
                    className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div className="flex flex-col">
                  <label
                    htmlFor="pincode"
                    className="text-sm font-medium text-gray-700 mb-1"
                  >
                    Pincode<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="pincode"
                    id="pincode"
                    placeholder="Postal Code"
                    value={form.pincode}
                    onChange={handleChange}
                    required
                    className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
              <div className="flex flex-col">
                {/* <label className="text-sm font-medium text-gray-700 mb-1">Apply Coupon</label> */}
                <div className="flex items-center space-x-2">
                  {/* <input
     type="text"
    placeholder="Enter coupon code"
    className="border border-gray-300 rounded px-3 py-2 w-1/2 focus:outline-none focus:ring-2 focus:ring-blue-500"
    onChange={(e) => setCouponInput(e.target.value.toUpperCase())}
    value={couponInput}
  />
  <button
    type="button"
    onClick={applyCoupon}
    className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
  >
    Apply
  </button> */}
                </div>

                {/* {selectedCoupon ? (
  <div className="mt-2 text-green-600">
    Coupon <strong>{selectedCoupon.coupon_code}</strong> applied!
    <br />
    {selectedCoupon.promotion_type === "Fixed" ? (
      <>Amount: {selectedCoupon.amount}</>
    ) : (
      <>Percentage: {parseFloat(selectedCoupon.amount)}%</>
    )}
  </div>
) : couponError ? (
  <div className="mt-2 text-red-600 font-medium">{couponError}</div>
): (
  <div className="mt-2 text-gray-500">No coupon selected</div>
)} */}
              </div>
              <div className="flex justify-between items-center pt-4 border-t">
                {/* <span className="text-xl font-semibold text-gray-800">
                {selectedCoupon ? (
                  <>
                    <p className="text-gray-500 line-through text-lg">
                      Original: ₹{totalAmount.toFixed(2)}
                    </p>
                    <p className="text-green-600 text-xl font-semibold">
                      Discounted Total: ₹{discountedTotal.toFixed(2)}
                    </p>
                  </>
                ) : (
                  <p className="text-xl font-semibold text-gray-800">
                    Total: ₹{totalAmount.toFixed(2)}
                  </p>
                )}
              </span> */}
                <div className="text-right space-y-1">
                  {/* Product Amount */}
                  <p className="text-gray-700">
                    Amount: ₹{discountedTotal.toFixed(2)}
                  </p>

                  {/* Delivery Charges */}
                  {deliveryCharge > 0 && (
                    <p className="text-gray-700">
                      Delivery Charges: ₹{deliveryCharge.toFixed(2)}
                    </p>
                  )}

                  {/* Final Total */}
                  <p className="text-xl font-bold text-green-600">
                    Total Amount: ₹{finalTotal.toFixed(2)}
                  </p>
                </div>

                <button
                  type="submit"
                  disabled={cart.length === 0}
                  className={`font-semibold px-6 py-2 rounded-lg transition ${
                    cart.length === 0
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-orange-600 hover:bg-orange-700 text-white"
                  }`}
                >
                  {/* Proceed to Pay */}
                  Buy
                </button>
              </div>
            </>
          )}
          {deliveryType === "takeaway" && (
            <div className="space-y-6">
              <h3 className="text-xl font-bold text-gray-800 border-b pb-2">
                Take Away
              </h3>
               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <div className="flex flex-col">
      <label className="text-sm font-medium text-gray-700 mb-1">
        Name<span className="text-red-500">*</span>
      </label>
      <input
        type="text"
        name="name"
        placeholder="Enter your name"
        value={form.name}
        onChange={handleChange}
        required
        className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>

    {/* <div className="flex flex-col">
      <label className="text-sm font-medium text-gray-700 mb-1">
        Phone Number
      </label>
      <input
        type="tel"
        name="phone"
        placeholder="Enter your phone number"
        value={form.phone}
        onChange={handleChange}
        required
        pattern="[0-9]{10}"
        maxLength={10}
        className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div> */}
    <div className="flex flex-col">
  <label
    htmlFor="phone"
    className="text-sm font-medium text-gray-700 mb-1"
  >
    Phone Number<span className="text-red-500">*</span>
  </label>

  {/* <div className="flex flex-col sm:flex-row gap-2"> */}
  <div className="flex items-center gap-2 flex-wrap">
    <input
      type="tel"
      name="phone"
      id="phone"
      placeholder="e.g. 9876543210"
      value={form.phone}
      onChange={handleChange}
      required
      maxLength={10}
        disabled={isPhoneVerified}
      // className="border border-gray-300 rounded-lg px-4 py-2 flex-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
     className={`border rounded-lg px-4 py-2 flex-1 focus:outline-none focus:ring-2 ${
    isPhoneVerified
      ? "border-green-300 bg-green-50 text-gray-600 cursor-not-allowed"
      : "border-gray-300 focus:ring-blue-500"
  }`}
    />

    {form.phone.length === 10 && !otpSent && !isPhoneVerified && (
      <button
        type="button"
        // onClick={() => setOtpSent(true)}
        onClick={handleSendOtp}
        className="bg-[#c97c5d] hover:bg-[#b86d4f] text-white px-4 py-2 rounded-lg font-medium transition"
      >
        Send OTP
      </button>
    )}

    {/* {isPhoneVerified && (
      <span className="px-4 py-2 rounded-lg bg-green-100 text-green-700 font-medium text-sm flex items-center">
        Verified
      </span>
    )} */}
    {isPhoneVerified && (
  <div className="flex items-center gap-3">
    <span className="px-4 py-2 rounded-lg bg-green-100 text-green-700 font-medium text-sm flex items-center">
      Verified
    </span>

    {localStorage.getItem(`verified_phone_${userId || "guest"}`) === form.phone && (
    

      <button
        type="button"
        onClick={() => {
          setIsPhoneVerified(false);
          setOtpSent(false);
          setOtp(["", "", "", ""]);
        }}
        // className="text-sm text-blue-600 hover:text-blue-800 underline"
        className="text-sm text-white bg-[#c97c5d] hover:bg-[#b86d4f] px-3 py-2 rounded-lg"
      >
        Change Number
      </button>
    )}
  </div>
)}
  </div>

  {otpSent && !isPhoneVerified && (
    // <div className="flex flex-col sm:flex-row gap-2 mt-3">
    //   <input
    //     type="text"
    //     placeholder="Enter OTP"
    //     value={otp}
    //     onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
    //     maxLength={6}
    //     className="border border-gray-300 rounded-lg px-4 py-2 flex-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
    //   />

    //   <button
    //     type="button"
    //     onClick={() => setIsPhoneVerified(true)}
    //     className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium transition"
    //   >
    //     Verify
    //   </button>
    // </div>
    <div className="flex flex-col sm:flex-row gap-2 mt-3 items-center">
  <div className="flex gap-2">
    {[...Array(4)].map((_, index) => (
      <input
        id={`otp-${index}`}
        key={index}
        type="text"
        maxLength={1}
        value={otp[index] || ""}
        onChange={(e) => handleOtpChange(e, index)}
        onKeyDown={(e) => handleOtpKeyDown(e, index)}
        className="w-10 h-12 text-center text-lg border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    ))}
  </div>
<div className="flex items-center gap-3 mt-3">
  {!canResendOtp ? (
    <span className="text-sm text-gray-600">
      Resend OTP in <span className="font-semibold text-orange-600">{otpTimer}s</span>
    </span>
  ) : (
    <button
      type="button"
      onClick={handleResendOtp}
      // className="text-sm bg-[#c97c5d] hover:bg-[#b86d4f] text-white px-3 py-2 rounded-lg"
       className="bg-[#c97c5d] hover:bg-orange-700 text-white px-4 py-2 rounded-lg font-medium -mt-4"
    >
      Resend OTP
    </button>
  )}
</div>
  {/* <button
    type="button"
    onClick={() => setIsPhoneVerified(true)}
    className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium"
  >
    Verify
  </button> */}
  <button
  type="button"
  onClick={() => {
    const currentPhone = form.phone.trim();

    if (currentPhone.length !== 10) return;

    localStorage.setItem(
      `verified_phone_${userId || "guest"}`,
      currentPhone
    );

    setIsPhoneVerified(true);
    setOtpSent(false);
  }}
  className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium"
>
  Verify
</button>
</div>
  )}
</div>
  </div>
              {/* <hr className="border-gray-200 mt-2 mb-4" /> */}
              {/* Address + Map Row */}
              {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6"> */}
              <div className="grid grid-cols-1 md:grid-cols-[1fr_1.6fr] gap-4">
                {/* LEFT: Store Address */}
                <div className="space-y-2 text-left pl-4 md:pl-6">
                  <p className="font-semibold text-gray-800 leading-relaxed">
                    Come and Collect your order at:
                  </p>
                  <p className="text-gray-600">
                    Malar’s Bakers
                    <br />
                    3/3B 5, 4th Street, <br />
                    Pasuvanthanai Rd,
                    <br />
                    Jothi Nagar, Kovilpatti, Thoothukudi,
                    <br />
                    Tamil Nadu – 628501
                  </p>
                </div>
                {/* RIGHT: Map + Button */}
                <div className="space-y-3">
                  <div className="w-full h-60 rounded-lg overflow-hidden border">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15755.253253462719!2d77.85491198301311!3d9.17130686459528!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06b3e412bad2db%3A0xdd25dd20f909d8bd!2sMalar's%20Bakers!5e0!3m2!1sen!2sin!4v1767955444710!5m2!1sen!2sin"
                      width="477"
                      height="300"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div>
                  <div className="flex justify-end">
                    <a
                      href="https://maps.app.goo.gl/7NJ4phNevQh53qDp9"
                      target="_blank"
                      rel="noopener noreferrer"
                      className=" ml-auto text-xs inline-block bg-green-600 hover:bg-green-700 text-white px-2 py-1 rounded-lg"
                    >
                      View in Map
                    </a>
                  </div>
                </div>
              </div>

              {/* Total + Pay */}
              <div className="flex justify-between items-center pt-4 border-t">
                <div className="text-right space-y-1">
                  {/* Product Amount */}
                  <p className="text-gray-700">
                    Amount: ₹{discountedTotal.toFixed(2)}
                  </p>

                  {/* Delivery Charges (Only if not takeaway) */}
                  {deliveryType !== "takeaway" && deliveryCharge > 0 && (
                    <p className="text-gray-700">
                      Delivery Charges: ₹{deliveryCharge.toFixed(2)}
                    </p>
                  )}

                  {/* Final Total */}
                  <p className="text-xl font-bold text-green-600">
                    Total Amount: ₹{finalTotal.toFixed(2)}
                  </p>
                </div>

                <button
                  type="submit"
                  disabled={cart.length === 0}
                  className={`font-semibold px-6 py-2 rounded-lg transition ${
                    cart.length === 0
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-orange-600 hover:bg-orange-700 text-white"
                  }`}
                >
                  {/* Proceed to Pay */}
                  Buy
                </button>
              </div>
            </div>
          )}
        </form>
      )}
    </div>
  );
};

export default CheckoutForm;







